export default __webpack_public_path__ + "static/6-b46bcec56662879c28fd03e5434c5baf.png";